import { atom } from 'jotai';

type BrokeredOrderFileDeleteParams = {
  fileId: string;
};

export const brokeredOrderFileDeleteMutationAtom = () =>
  atom(
    null,
    async (
      _get,
      _set,
      _params: BrokeredOrderFileDeleteParams,
    ): Promise<void> => {
      throw new Error(
        'Not implemented: brokeredOrderFileDelete backend API pending',
      );
    },
  );
